import { appConfig } from '../constants/app-config';

export const angularCoreConfigModule = angular
  .module('Q.config.angular-log', [])

  .config(function ($logProvider, $compileProvider, $qProvider) {
    // Only log debug events on dev mode
    $logProvider.debugEnabled(appConfig.devMode);

    // Only render debug data on dev mode, or when debug=true in the URL
    $compileProvider.debugInfoEnabled(
      appConfig.devMode || /debug=true/.test(window.location.search),
    );

    // Prevent $q from throwing errors on unhandled rejections on newer versions
    if ($qProvider.errorOnUnhandledRejections) {
      // TODO: is it worth cleaning up the codebase for this?
      $qProvider.errorOnUnhandledRejections(false);
    }
  })
  .run(function ($timeout) {
    // Disables pre-load error handling after the application loads
    $timeout(
      () => {
        // At this point, we should be able to rely on Angular for rendering errors
        appConfig.isLoaded = true;
      },
      1,
      false,
    );
  });
